import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { FeedbackButton } from './FeedbackButton';
import { useAgentConfig } from '../../../contexts/AgentConfigContext';
export const FeedbackButtons = ({ messageInfo, dataId }) => {
    var _a;
    const [feedbackSent, setFeedbackSent] = useState(null);
    const { config: aiConfig, getBaseUrlFromAgentUrl } = useAgentConfig();
    // Only show feedback buttons for agent messages with a valid thread ID and authenticated user
    if (messageInfo.messageType !== 'A' || !((_a = messageInfo.userInfo) === null || _a === void 0 ? void 0 : _a.isAgent) || !messageInfo.threadId || !messageInfo.auth) {
        return null;
    }
    const handleFeedbackSent = (feedbackType) => {
        setFeedbackSent(feedbackType);
    };
    const baseUrl = (aiConfig === null || aiConfig === void 0 ? void 0 : aiConfig.agent_url) ? getBaseUrlFromAgentUrl(aiConfig.agent_url) : undefined;
    // If feedback has been sent, only show the selected button (disabled)
    if (feedbackSent) {
        return (_jsx(FeedbackButton, { buttonType: feedbackSent, threadId: messageInfo.threadId, dataId: `${dataId}-${feedbackSent}-button`, onFeedbackSent: handleFeedbackSent, disabled: true, isSelected: true, auth: messageInfo.auth, baseUrl: baseUrl }));
    }
    // Show both buttons if no feedback has been sent yet
    return (_jsxs(_Fragment, { children: [_jsx(FeedbackButton, { buttonType: "like", threadId: messageInfo.threadId, dataId: `${dataId}-like-button`, onFeedbackSent: handleFeedbackSent, auth: messageInfo.auth, baseUrl: baseUrl }), _jsx(FeedbackButton, { buttonType: "dislike", threadId: messageInfo.threadId, dataId: `${dataId}-dislike-button`, onFeedbackSent: handleFeedbackSent, auth: messageInfo.auth, baseUrl: baseUrl })] }));
};
